export default __webpack_public_path__ + "logo-02f85d18.png";